import { LabelInValueType } from "rc-select/lib/Select";
import { transformSearchParamsToObject } from "utils/searchParamsToObject";
import { findNodeById, OptionType } from "utils/formatCategories";

export const parseCategoryFilters = (
  tree: OptionType[],
  searchKey: string,
  params: URLSearchParams
): LabelInValueType[] => {
  const searchParams: Record<string, any> = transformSearchParamsToObject(params);

  return parseFilterValues(
    searchParams[searchKey],
    (id: number) => {
      const node: OptionType = findNodeById(tree, id);

      return node?.value ? { value: node.value, label: node.label } : null;
    }
  );
};

const parseFilterValues = <T>(
  value: unknown,
  resolver: (id: number) => T | null | undefined
): T[] => {
  const result: T[] = [];

  const addItem = (item: any): void => {
    const resolved: T = resolver(Number(item));

    if (resolved) result.push(resolved);
  };

  if (Array.isArray(value)) {
    value.forEach(addItem);
  } else if (value !== undefined && value !== null) {
    addItem(value);
  }

  return result;
};
